// extracted by mini-css-extract-plugin
export default {"root":"JbisyymL","errorCode":"SxiPq1Lc","errorMessage":"WEwFvg4T","errorBackground":"CjGQsmje","errorGround":"QMAzf5Wf"};